import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { isExtendConsent, isUpdateConsent } from '../../models/product';
import { useProduct } from '../../components/ApplicationProviders/ProductProvider/ProductProvider';
import { AppState } from '../../stores/redux-store';
import { LoadingOverlay } from '../screens/LoadingOverlay/LoadingOverlay';
import {
  CredentialsFinderUpdateConsent as CredentialsFinderUpdateConsentImport,
  CredentialsFinderUpdateConsentOwnProps,
} from './organism/CredentialsFinderUpdateConsent/CredentialsFinderUpdateConsent';

export type CredentialsInitiatorProps = PropsFromRedux & {
  children: React.ReactNode;
  CredentialsFinderUpdateConsent?: React.ComponentType<CredentialsFinderUpdateConsentOwnProps>;
};

export const CredentialsInitiatorPresenter: React.FC<CredentialsInitiatorProps> = ({
  user,
  children,
  CredentialsFinderUpdateConsent = CredentialsFinderUpdateConsentImport,
}) => {
  const { productType, productDimension } = useProduct();

  const isExtendConsentFlow = isExtendConsent(productDimension);
  const isUpdateConsentProduct = isUpdateConsent(productType, productDimension);
  const isRelevantProduct = isUpdateConsentProduct || isExtendConsentFlow;

  if (!isRelevantProduct) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  if (!user) {
    return <LoadingOverlay />;
  }

  if (isUpdateConsentProduct || isExtendConsentFlow) {
    return <CredentialsFinderUpdateConsent>{children}</CredentialsFinderUpdateConsent>;
  }

  throw new Error('Unhandled credentials initiator case ');
};

const mapStateToProps = (state: AppState) => {
  return {
    user: state.user.user,
  };
};

const connector = connect(mapStateToProps, {});

type PropsFromRedux = ConnectedProps<typeof connector>;

export const CredentialsInitiator = connector(CredentialsInitiatorPresenter);
